import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({ isOpen, handleClose, handleResetNow, action}) {
  const [open, setOpen] = useState(isOpen);
  const handleClosing = () => {
    setOpen(false);
  };
  const handleCloseYes = () => {
    setOpen(false);
    handleClose();
    handleResetNow();
  };
  const handleCloseNo = () => {
    handleClose();
    setOpen(false);
  };

  return open ? (
    <div>
      {/* <Button variant="danger" onClick={handleClickOpen}>
        Cancel
      </Button> */}
      <Dialog
        open={isOpen}
        onClose={handleClosing}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "red" }} id="alert-dialog-title">
          Confirm {action}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to {action}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNo} autoFocus>
            No
          </Button>
          <Button type="reset" onClick={handleCloseYes}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  ) : (
    <div></div>
  );
}
